<template>
    <div class="flex flex-wrap justify-center">
        <div
            v-for="(item, index) in items"
            :key="item.key"
            :class="[
                isDesktop ? 'p-2' : 'p-1.5',
                isHero(index)
                    ? isDesktop
                        ? 'w-full max-w-lg'
                        : 'w-full'
                    : isDesktop
                    ? 'w-1/3'
                    : 'w-1/2'
            ]"
        >
            <component
                :is="item.href ? 'a' : 'div'"
                v-bind="linkAttrs(item)"
                :aria-label="item.title"
                class="group relative block w-full overflow-hidden rounded-2xl bg-stack-text no-underline shadow-xl"
                :class="[
                    isHero(index)
                        ? 'aspect-banner'
                        : isDesktop
                        ? 'h-56'
                        : 'h-40',
                    { 'cursor-pointer': item.href }
                ]"
                @click="onClick"
            >
                <img
                    v-if="item.imageUrl"
                    :src="item.imageUrl"
                    :alt="item.imageAlt"
                    class="absolute inset-0 h-full w-full transform object-cover transition-transform duration-700 ease-out group-hover:scale-110"
                />
                <div v-else class="absolute inset-0">
                    <slot name="placeholder" :item="item"></slot>
                </div>
            </component>
        </div>
    </div>
</template>

<script>
export default {
    name: "SliderV9",
    props: {
        items: { type: Array, required: true },
        previewOnly: { type: Boolean, default: false },
        isDesktop: { type: Boolean, default: true }
    },
    methods: {
        // Grupos de 6: el primero de cada grupo es la hero (fila completa,
        // nivel lg) y los otros 5 van debajo en nivel md.
        isHero(index) {
            return index % 6 === 0;
        },
        linkAttrs(item) {
            return item.href
                ? { href: item.href, target: item.target, rel: item.rel }
                : {};
        },
        onClick(event) {
            if (this.previewOnly) event.preventDefault();
        }
    }
};
</script>
